import api from "./axios"; 

export const checkRejection = async () => {
    try {
      const response = await api.get("/api/v1/customer/users/latestrejection");
      return response.data;
    } catch (error) {
      console.error(error.response?.data?.message || "Failed to update status");
    }
  };